import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/CWP_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-1bde53ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-area" }
const _hoisted_2 = { class: "form-signin w-100 m-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "45",
    class: "ms-auto me-2"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "ms-2 h3 mb-0 fw-normal me-auto" }, " Car Wash Priority ")
], -1))
const _hoisted_4 = { class: "form-floating mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Номер телефона", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingPassword" }, "Код из СМС или звонка", -1))
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback mb-2"
}
const _hoisted_8 = { class: "mb-3 text-center" }
const _hoisted_9 = {
  key: 1,
  class: "text-secondary"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-secondary text-center" }, [
  /*#__PURE__*/_createTextVNode(" Считай QR код и оплати в несколько касаний. Начисляем кеш-бэки за мойку и сообщаем об акциях. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://carwashpriority.ru/",
    target: "_blank"
  }, "https://carwashpriority.ru/")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_g_card = _resolveComponent("g-card")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_g_card, {
        "is-opacity-loader": _ctx.state.isLoading
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetError && _ctx.resetError(...args)))
              }, null, 544), [
                [_vModelText, _ctx.phone],
                [_directive_maska, `+7 (###) ###-####`]
              ]),
              _hoisted_5
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["form-floating mb-2", {'is-invalid': _ctx.error.show}])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event))
              }, null, 512), [
                [_vModelText, _ctx.code]
              ]),
              _hoisted_6
            ], 2),
            (_ctx.error.show)
              ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString(_ctx.error.msg), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.seconds_to_send === 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "text-decoration-none",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getFlashCall && _ctx.getFlashCall(...args)))
                  }, "Запросить код"))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, " Запросить еще раз через " + _toDisplayString(_ctx.seconds_to_send) + " сек. ", 1))
            ]),
            _createElementVNode("button", {
              class: "w-100 btn btn-lg btn-success",
              type: "submit",
              disabled: _ctx.phone.length < 17 || _ctx.code.length < 4
            }, "Войти", 8, _hoisted_10)
          ], 32)
        ]),
        _: 1
      }, 8, ["is-opacity-loader"]),
      _hoisted_11
    ])
  ]))
}